import React from 'react';
import { BookOpen, Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black py-12 px-4 border-t border-white/10" data-id="element-149">
      <div className="max-w-6xl mx-auto text-center" data-id="element-150">
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-151">
          <BookOpen className="w-8 h-8 text-brand-gold" data-id="element-152" />
          <span className="font-heading font-bold text-2xl tracking-tight" data-id="element-153">
            BIBLIOTECAS <span className="text-brand-gold" data-id="element-154">DIGITALES™</span>
          </span>
        </div>

        <p className="text-gray-400 max-w-md mx-auto mb-8" data-id="element-155">
          El sistema N°1 para resolver la comida diaria de hogares argentinos.
          Porque comer bien todos los días no debería costarte todos los
          domingos del año.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-gray-500 mb-12" data-id="element-156">
          <a href="mailto:soportebibliotecasdigitales@gmail.com" className="flex items-center gap-2 hover:text-brand-gold transition-colors" data-id="element-157">
            <Mail className="w-4 h-4" data-id="element-158" /> soportebibliotecasdigitales@gmail.com
          </a>
          <a href="https://www.bibliotecasdigitales.store" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-gold transition-colors" data-id="element-159">
            <Globe className="w-4 h-4" data-id="element-160" /> www.bibliotecasdigitales.store
          </a>
        </div>

        <div className="text-xs text-gray-600 border-t border-white/5 pt-8" data-id="element-161">
          <p className="mb-2" data-id="element-162">
            © Bibliotecas Digitales™ 2025 — Todos los derechos reservados.
          </p>
          <p className="italic" data-id="element-163">"El próximo domingo puede ser diferente." 📚</p>
        </div>
      </div>
    </footer>;
}